import { render, staticRenderFns } from "./sideboardOrder.vue?vue&type=template&id=5a7adce2&scoped=true&"
import script from "./sideboardOrder.vue?vue&type=script&lang=js&"
export * from "./sideboardOrder.vue?vue&type=script&lang=js&"
import style0 from "./sideboardOrder.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./sideboardOrder.vue?vue&type=style&index=1&id=5a7adce2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7adce2",
  null
  
)

export default component.exports